/**
 * Spinner — 로딩 상태를 표현하는 원형 인디케이터
 */

import { cn } from '../../lib/cn.js'
import styles from './Spinner.module.css'

interface SpinnerProps {
  /** 스피너 크기. 기본값 md */
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="로딩 중"
      className={cn(styles.root, styles[size], className)}
    />
  )
}
